import styled from "styled-components";
import rem from "../../utils/rem";

const Input = styled.input`
  background-color: inherit;
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid palevioletred;
  border-left: 0;
  color: rgba(0, 0, 0, 0.54);
  font-size: ${rem(14)};
  height: 20px;
  padding: 0;
  width: 80%;

  &:focus {
    outline: none;
  }
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/elements/Input.js